import { render, staticRenderFns } from "./criticism.vue?vue&type=template&id=76c131f0&"
import script from "./criticism.vue?vue&type=script&lang=js&"
export * from "./criticism.vue?vue&type=script&lang=js&"
import style0 from "./criticism.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports